import React, { useId } from 'react';

/**
 * Inline (i) control — shows detail on hover and keyboard focus.
 */
export default function PerfHubSectionInfo({ label, children, className = '' }) {
  const tipId = useId();

  return (
    <span className={`ph-section-info ${className}`.trim()}>
      <button
        type="button"
        className="ph-section-info-btn"
        aria-label={`About ${label}`}
        aria-describedby={tipId}
      >
        <span className="ph-section-info-icon" aria-hidden>
          i
        </span>
      </button>
      <span id={tipId} role="tooltip" className="ph-section-info-tip">
        {children}
      </span>
    </span>
  );
}
